import { Suspense } from 'react';
import LoadingSpinner from '@/components/common/LoadingSpinner';
import { lazyWithRetry } from '@/utils/lazyRetry';

// Lazy load all page components with retry mechanism
const Profile = lazyWithRetry(() => import('@/pages/Profile'));
const Index = lazyWithRetry(() => import('@/pages/Index'));
const Event = lazyWithRetry(() => import('@/pages/Event'));
const About = lazyWithRetry(() => import('@/pages/About'));
const Customizations = lazyWithRetry(() => import('@/pages/Customizations'));
const MyTickets = lazyWithRetry(() => import('@/pages/MyTickets'));

// Admin pages
const AdminStats = lazyWithRetry(() => import('@/pages/AdminStats'));
const AdminTools = lazyWithRetry(() => import('@/pages/AdminTools'));
const AdminUsers = lazyWithRetry(() => import('@/pages/AdminUsers'));
const AdminPayments = lazyWithRetry(() => import('@/pages/AdminPayments'));
const AdminTickets = lazyWithRetry(() => import('@/pages/AdminTickets'));
const AdminBillboards = lazyWithRetry(() => import('@/pages/AdminBillboards'));
const AdminGroups = lazyWithRetry(() => import('@/pages/AdminGroups'));
const AdminMunicipalities = lazyWithRetry(() => import('@/pages/AdminMunicipalities'));
const CreateEvent = lazyWithRetry(() => import('@/pages/CreateEvent'));
const EditEvents = lazyWithRetry(() => import('@/pages/EditEvents'));

// Wrapper component for lazy loaded components
const LazyWrapper = ({ children }: { children: React.ReactNode }) => (
  <Suspense fallback={<LoadingSpinner />}>
    {children}
  </Suspense>
);

export {
  Profile,
  Index,
  Event,
  About,
  Customizations,
  MyTickets,
  AdminStats,
  AdminTools,
  AdminUsers,
  AdminPayments,
  AdminTickets,
  AdminBillboards,
  AdminGroups,
  AdminMunicipalities,
  CreateEvent,
  EditEvents,
  LazyWrapper
};